import { type OffersForSaleSchema } from '@b2ag/types-api-schemas'
import {
  type EnhancedLogisticOfferForSale,
  enhanceLogisticOffersForSale,
  type LogisticOfferForSale,
} from '@invivodf/module-logistic-offer-client-sdk'
import { toISODateString } from '@b2ag/l10n'

export function mapLogisticOffers(offer: OffersForSaleSchema[number]): EnhancedLogisticOfferForSale[] {
  const today = toISODateString(new Date())
  const logisticOffers =
    offer.logistic_offers?.map(
      (logisticOffer) =>
        ({
          ...logisticOffer,
        }) as unknown as LogisticOfferForSale, // offer repo does not have the real type
    ) || []
  return enhanceLogisticOffersForSale(logisticOffers, today)
}
